export default "__VITE_ASSET__uIv1jC7N__"